export default "__VITE_ASSET__272ef2dc__"